import {
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  LateInitSignal30crwrg540xyy as LateInitSignal,
} from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { set_value1vvx5pkb20ebv as set_value } from '../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { Key_instance6wd16m35aua5 as Key_instance } from '../../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import {
  get_animationsEnabled25ujr8oia8gbs as get_animationsEnabled,
  set_animationsEnabled1ac1lbh50s602 as set_animationsEnabled,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/RView.js.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { checkIndexOverflow3frtmheghr0th as checkIndexOverflow } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { getOrNull1go7ef9ldk0df as getOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { reactive2pl1t9wy5gll5 as reactive } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CellClass;
function Cell() {
  if (CellClass === VOID) {
    class $ {
      static bgf(container, rendererSet, data, id, renderer, index) {
        var $this = createThis(this);
        $this.uge_1 = rendererSet;
        $this.vge_1 = data;
        $this.wge_1 = id;
        $this.xge_1 = renderer;
        $this.yge_1 = _Constant___init__impl__v45mub(index);
        var tmp = $this;
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (Frame())(container.pc());
        var tmp0_elvis_lhs = container.cbb_1;
        var p = tmp0_elvis_lhs == null ? container : tmp0_elvis_lhs;
        container.ebb(p, view);
        renderer.ndg(view, $this.vge_1, new (Constant())($this.yge_1));
        container.fbb(p, view);
        tmp.zge_1 = view;
        $this.agf_1 = false;
        return $this;
      }
      static cgf(container, set, data, index) {
        // Inline function 'kotlin.apply' call
        var this_0 = LateInitSignal().raq();
        set_value(this_0, data);
        return this.bgf(container, set, this_0, set.idg(data), set.hdg(data), index);
      }
      cah(readable) {
        if (this.agf_1)
          return Unit_instance;
        this.agf_1 = true;
        var tmp0_safe_receiver = this.zge_1.ea2().cd(Key_instance);
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.cah(readable);
        }
      }
      hdc() {
        // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
        var tmp = this.zge_1.tb5_1.vb3_1;
        var tmp0_safe_receiver = tmp instanceof HTMLElement ? tmp : null;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
          var this_0 = tmp0_safe_receiver;
          var animate = get_animationsEnabled();
          try {
            if (animate) {
              set_animationsEnabled(false);
              // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
              // Inline function 'kotlin.js.asDynamic' call
              var tmp_1 = this_0.__suppressMutationObserverClass;
              var tmp0_elvis_lhs = tmp_1 instanceof ArrayList() ? tmp_1 : null;
              var tmp_2;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'kotlin.run' call
                var n = ArrayList().w();
                // Inline function 'kotlin.js.asDynamic' call
                this_0.__suppressMutationObserverClass = n;
                tmp_2 = n;
              } else {
                tmp_2 = tmp0_elvis_lhs;
              }
              var e = tmp_2;
              this_0.classList.add('notransition');
              var tmp1_elvis_lhs = this_0.getAttribute('class');
              e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
            }
            this.zge_1.hb7(false);
          }finally {
            if (animate) {
              var tmp_3 = window;
              tmp_3.setTimeout(() => {
                // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
                var this_1 = this_0;
                // Inline function 'kotlin.js.asDynamic' call
                var tmp = this_1.__suppressMutationObserverClass;
                var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
                var tmp_0;
                if (tmp0_elvis_lhs == null) {
                  // Inline function 'kotlin.run' call
                  var n = ArrayList().w();
                  // Inline function 'kotlin.js.asDynamic' call
                  this_1.__suppressMutationObserverClass = n;
                  tmp_0 = n;
                } else {
                  tmp_0 = tmp0_elvis_lhs;
                }
                var e = tmp_0;
                this_0.classList.remove('notransition');
                var tmp1_elvis_lhs = this_1.getAttribute('class');
                e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
                return Unit_instance;
              }, 100);
              set_animationsEnabled(true);
            }
          }
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          this.zge_1.hb7(false);
        }
      }
      dgf(value) {
        this.zge_1.bba(true);
        if (equals(this.uge_1.idg(value), this.wge_1)) {
          set_value(this.vge_1, value);
        } else {
          var r = this.uge_1.hdg(value);
          if (r === this.xge_1 || equals(r, this.xge_1)) {
            set_value(this.vge_1, value);
          } else {
            this.xge_1 = r;
            // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
            var tmp = this.zge_1.tb5_1.vb3_1;
            var tmp0_safe_receiver = tmp instanceof HTMLElement ? tmp : null;
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'com.lightningkite.kiteui.views.withoutAnimation' call
              var this_0 = tmp0_safe_receiver;
              var animate = get_animationsEnabled();
              try {
                if (animate) {
                  set_animationsEnabled(false);
                  // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
                  // Inline function 'kotlin.js.asDynamic' call
                  var tmp_1 = this_0.__suppressMutationObserverClass;
                  var tmp0_elvis_lhs = tmp_1 instanceof ArrayList() ? tmp_1 : null;
                  var tmp_2;
                  if (tmp0_elvis_lhs == null) {
                    // Inline function 'kotlin.run' call
                    var n = ArrayList().w();
                    // Inline function 'kotlin.js.asDynamic' call
                    this_0.__suppressMutationObserverClass = n;
                    tmp_2 = n;
                  } else {
                    tmp_2 = tmp0_elvis_lhs;
                  }
                  var e = tmp_2;
                  this_0.classList.add('notransition');
                  var tmp1_elvis_lhs = this_0.getAttribute('class');
                  e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
                }
                this.zge_1.zb9();
                set_value(this.vge_1, value);
                r.ndg(this.zge_1, this.vge_1, new (Constant())(this.yge_1));
              }finally {
                if (animate) {
                  var tmp_3 = window;
                  tmp_3.setTimeout(() => {
                    // Inline function 'com.lightningkite.kiteui.views.direct.suppressMutationObserverForClass' call
                    var this_1 = this_0;
                    // Inline function 'kotlin.js.asDynamic' call
                    var tmp = this_1.__suppressMutationObserverClass;
                    var tmp0_elvis_lhs = tmp instanceof ArrayList() ? tmp : null;
                    var tmp_0;
                    if (tmp0_elvis_lhs == null) {
                      // Inline function 'kotlin.run' call
                      var n = ArrayList().w();
                      // Inline function 'kotlin.js.asDynamic' call
                      this_1.__suppressMutationObserverClass = n;
                      tmp_0 = n;
                    } else {
                      tmp_0 = tmp0_elvis_lhs;
                    }
                    var e = tmp_0;
                    this_0.classList.remove('notransition');
                    var tmp1_elvis_lhs = this_1.getAttribute('class');
                    e.v(tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
                    return Unit_instance;
                  }, 100);
                  set_animationsEnabled(true);
                }
              }
              tmp_0 = Unit_instance;
            }
            if (tmp_0 == null) {
              this.zge_1.zb9();
              set_value(this.vge_1, value);
              r.ndg(this.zge_1, this.vge_1, new (Constant())(this.yge_1));
            }
          }
        }
      }
    }
    initMetadataForClass($, 'Cell');
    CellClass = $;
  }
  return CellClass;
}
function forEachWithRenderer(_this__u8e3s4, items, rendererSet, loadingRenderers) {
  loadingRenderers = loadingRenderers === VOID ? emptyList() : loadingRenderers;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(loadingRenderers, 10));
  var index = 0;
  var _iterator__ex2g4s = loadingRenderers.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var idx = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$0 = Cell().bgf(_this__u8e3s4, rendererSet, LateInitSignal().raq(), null, item, idx);
    destination.v(tmp$ret$0);
  }
  var currentViews = ArrayList().b1(destination);
  reactive(_this__u8e3s4, ($this$reactive) => {
    var list = $this$reactive.baj(items);
    var iterator = list.m1();
    var index = 0;
    while (iterator.n1()) {
      var idx = index;
      index = index + 1 | 0;
      var item = iterator.o1();
      var tmp0_safe_receiver = getOrNull(currentViews, idx);
      var tmp;
      if (tmp0_safe_receiver == null) {
        tmp = null;
      } else {
        tmp0_safe_receiver.dgf(item);
        tmp = Unit_instance;
      }
      if (tmp == null)
        currentViews.v(Cell().cgf(_this__u8e3s4, rendererSet, item, idx));
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = currentViews.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      element.cah($this$reactive);
    }
    var tmp_0;
    if (currentViews.p1() > list.p1()) {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = currentViews.m3(list.p1(), currentViews.p1()).m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        element_0.hdc();
      }
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  });
}
//region block: exports
export {
  forEachWithRenderer as forEachWithRenderer12ybmdeyp3omm,
};
//endregion

//# sourceMappingURL=forEachWithRenderer.mjs.map
